module.exports = __webpack_public_path__ + "static/img/mars_weixin_img.b32c3cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/mars_weixin_img.jpg
// module id = 7gWj
// module chunks = 41